/* unplugin-vue-components disabled */import { render } from "./termsOfService.vue?vue&type=template&id=a0ade9b8&scoped=true"
import script from "./termsOfService.vue?vue&type=script&lang=js"
export * from "./termsOfService.vue?vue&type=script&lang=js"

import "./termsOfService.vue?vue&type=style&index=0&id=a0ade9b8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0ade9b8"]])

export default __exports__